import { BIZ_SELECT_KEY } from "./constants";
import { currentAuthUser } from "./api";

// Determine the active business id from localStorage or current user payload.
export function getActiveBusinessId(): number | null {
  try {
    const stored = localStorage.getItem(BIZ_SELECT_KEY);
    if (stored) {
      const parsed = parseInt(stored, 10);
      if (!Number.isNaN(parsed)) return parsed;
    }
  } catch (e) {
    if (import.meta.env?.DEV) console.error("Error reading BIZ_SELECT_KEY", e);
  }
  const user = currentAuthUser() as Record<string, unknown> | null;
  if (user && typeof user === 'object' && 'business_id' in user) return user.business_id as number;
  if (user && typeof user === 'object' && 'businesses' in user && Array.isArray(user.businesses) && user.businesses.length) {
    const first = user.businesses[0] as Record<string, unknown> | undefined;
    return (first?.business_id as number) || null;
  }
  return null;
}
